/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import GlobalContext from '../Context/GloablContext';

const EmptyScreen = ({tittle, type}) => {
    const {isSideNavBar}=useContext(GlobalContext)
    const location=useNavigate()
    useEffect(() => {
        if(window.location.pathname!=='/404' &&tittle==='404')
            location('/404')
    }, [])
    
    return (
        <div class={`w-full main-screen3 overflow-x-hidden overflow-y-auto relative h-screen px-10 pt-[17px] pb-[5px]  ${type === "not-logged" ? " w-[100%]" : `${!isSideNavBar ? ' w-[270px] ' : ''}`}`}>
            {tittle !== "404" && <div class="flex justify-between">
                <h5 class="pageHeader relative">{"Sign In /Sign Out"}</h5>
            </div>}
            <div class="h-customhei1 w-full flex justify-center items-center">
                <div>
                    <p class="text-f2 font-medium text-[#000000] pt-6">{tittle === "404" ?  "404 - Page Not Found. Oops! The page you are looking for does not exist" : "We couldn't find anything in Sign In /Sign Out"}.</p>
                </div>
            </div>
        </div>
    );
}

export default EmptyScreen;
